/**
 * 
 */
export enum ExternalVariableHumidity {
    RelativeHumidity = "RH",
    HumidityRatio = "HR",
}